import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import RangeSlider from '../../range-slider';

const _styles = require('./RoomsFilter.scss');

interface Props {
    isVisible: boolean;
    min: number;
    max: number | null;
    defaultValue?: [number, number | null];
    onChange?: (value: number[]) => void;
}

const STEP = 1;
const MAX_DISCRETE = 500;
export const MAX = MAX_DISCRETE + STEP;

/**
 * Logic for converting a number value to text to display on either end of the
 * budget range slider
 *
 * @param val number value to convert to text
 */
const formatBudgetText = (val: number) => {
    if (val === MAX || val === 0) {
        return 'Any';
    }

    return `${val}`;
};

export const RoomsFilter = (props: Props) => {
    const { isVisible, min, max, defaultValue, onChange } = props;

    let _max = max || MAX;
    let _defaultValues = defaultValue ? [defaultValue[0], defaultValue[1] || MAX] : [0, MAX];

    const [onFormChange] = useDebouncedCallback((values: number[]) => {
        onChange && onChange(values);
    }, 250);

    return (
        <div className={_styles.sliderContainer}>
            <RangeSlider
                key={JSON.stringify(_defaultValues)}
                formikName='rooms'
                showHandleText={isVisible}
                onChange={onFormChange}
                defaultValue={_defaultValues}
                pushable={STEP * 10}
                min={min}
                max={_max}
                step={STEP}
                formatHandleText={formatBudgetText}
            />
        </div>
    );
};
